module.exports = __webpack_public_path__ + "static/img/icon-minus.5789db3.png";